import type { HotelOffersResponse, HotelResponse, MapOffersResponse, OfferResponse, OffersResponse } from '@/interfaces';
import { type QueryParams, stringifyParams } from '@/lib/utils/queryString';

const apiFetch = async <T>(url: string): Promise<T | null> => {
    const response = await fetch(url);
    if (response.status === 304) {
        return null; // Not modified
    }
    if (!response.ok) {
        throw new Error(`(${response.status}) ${response.statusText}`);
    }
    return response.json();
};

export const fetchOffers = async (baseUrl: string, params: QueryParams = {}): Promise<OffersResponse | null> => {
    const query = stringifyParams(params);
    const url = `${baseUrl}/offers${query ? `?${query}` : ''}`;
    return apiFetch<OffersResponse>(url);
};

export const fetchOffersForMap = async (baseUrl: string, params: QueryParams = {}): Promise<MapOffersResponse | null> => {
    const query = stringifyParams(params);
    const url = `${baseUrl}/offers/map${query ? `?${query}` : ''}`;
    return apiFetch<MapOffersResponse>(url);
};

export const fetchOffer = async (baseUrl: string, params: QueryParams = {}): Promise<OfferResponse | null> => {
    const query = stringifyParams(params);
    const url = `${baseUrl}/offer${query ? `?${query}` : ''}`;
    return apiFetch<OfferResponse>(url);
};

export const fetchOffersForHotel = async (baseUrl: string, params: QueryParams = {}): Promise<HotelOffersResponse | null> => {
    const { hotelId, ...rest } = params;
    const query = stringifyParams(rest);
    const url = `${baseUrl}/hotel/offers/${encodeURIComponent(hotelId as string)}${query ? `?${query}` : ''}`;
    return apiFetch<HotelOffersResponse>(url);
};

export const fetchHotel = async (baseUrl: string, params: QueryParams = {}): Promise<HotelResponse | null> => {
    const { hotelId, preferredSupplier } = params;
    const url = `${baseUrl}/hotel/${encodeURIComponent(hotelId as string)}${preferredSupplier ? `?preferredSupplier=${encodeURIComponent(preferredSupplier as string)}` : ''}`;
    return apiFetch<HotelResponse>(url);
};
